import { useTranslation } from 'react-i18next';
import { DATE_TIME_FORMAT_NAME_MODEL, getDateFormat, getTimeFormat } from '../../../../Apis/functions';
import { IconDateTimeCalendar } from '../../../../components/buttons/IconButtons';
import { EVENT_DEFAULT_ICON, getElapsedTime, getMetaValue } from '../Model/Model';
import { getSeverity } from './EventMonitoringCommon';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Data of an event row: severity colors, elapsed time and its meta items followed by the date. The meta items
 * are split in rows, an item with newRow starts a new one.
 */
const EventFeedRowApp = ({ event, now }) => {
    const { t } = useTranslation();
    const severity = getSeverity(event?.severity);
    const elapsed = t('X_MIN_ago', { min: getElapsedTime(event?.date, now) });

    const metaItems = [
        // The value of every item is read on every render, the ones with elapsedFrom grow with now //
        ...(event?.meta ?? []).map((item) => ({ ...item, value: getMetaValue(item, now, t) })),
        {
            Icon: IconDateTimeCalendar,
            label: 'date_time',
            value: `${getDateFormat(event?.date, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)} ${getTimeFormat(event?.date)}`,
        },
    ];

    const metaRows = metaItems.reduce((rows, item, index) => {
        if (item.newRow && index > 0) rows.push([]);
        rows[rows.length - 1].push(item);
        return rows;
    }, [[]]);

    return {
        severity,
        elapsed,
        metaRows,
        label: t(event?.label, event?.labelValues),
        Icon: event?.pictogram ?? EVENT_DEFAULT_ICON
    };
};

export default EventFeedRowApp;
